
import ProductsHero from './components/ProductsHero';
import ProductsCatalog from './components/ProductsCatalog';
import ProductsCTA from './components/ProductsCTA';

export default function ProductsPage() {
  return (
    <div className="min-h-screen">
      <ProductsHero />
      <ProductsCatalog />
      <ProductsCTA />
    </div>
  );
}